const getAFlow = (data: number, normMin: number, normMax: number) => {
  let end;

  if (data >= normMin && data <= normMax) {
    end = (data - normMin) * (100 / (normMax - normMin)) * 0.3 + 35;
  } else if (data < normMin) {
    end = data * (100 / normMin) * 0.35;
  } else if (data >= normMax && data < normMax * 2) {
    end = (data - normMax) * (100 / normMax) * 0.35 + 65;
  } else if (data > normMax && data >= normMax * 2) {
    end = 100;
  }

  return end;
};

const getBFlow = (data: number, normMin: number) => {
  let end;

  if (data > normMin && data < normMin * 2) {
    end = (data - normMin) * (100 / normMin) * 0.65 + 35;
  } else if (data >= normMin * 2) {
    end = 100;
  } else if (data <= normMin) {
    end = data * (100 / normMin) * 0.35;
  }

  return end;
};

const getCFlow = (data: number, normMin: number, normMax: number) => {
  let end;

  if (data >= 0 && data < normMax) {
    end = data * (100 / normMax) * 0.65;
  } else if (data >= normMax && data < normMax * 2) {
    end = (data - normMax) * (100 / normMax) * 0.35 + 65;
  } else if (data >= normMax * 2) {
    end = 100;
  }

  return end;
};

export const getEnd = (
  data: number | undefined,
  normMin: number | undefined,
  normMax: number | undefined,
  totalValue: number
) => {
  let end;

  if (!data) {
    return 0;
  }

  if (!normMin && !normMax) {
    return (data / totalValue) * 50;
  }

  if (normMin && normMax && normMin > 0 && normMax < Infinity) {
    end = getAFlow(data, normMin, normMax);
  } else if (normMin && normMin > 0 && (!normMax || normMax === Infinity)) {
    end = getBFlow(data, normMin);
  } else if (normMin === 0 && normMax && isFinite(normMax)) {
    end = getCFlow(data, normMin, normMax);
  }

  return end || 0;
};
